import mixpanel from 'mixpanel-browser';
import branch from 'branch-sdk';

let TRACKING_INIT = false;

export function initTracking() {
    mixpanel.init('f70da51df62912ad4b8614931a549bea');
    mixpanel.reset();
    branch.init('key_live_nvfEMpH1gX0IR5x4ESCQ2bdjBCkzyFYh');
    TRACKING_INIT = true;
}

export function logEvent({ event, submodule, functionality }) {
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    if (TRACKING_INIT) {
        const eventData = {
            submodule,
            functionality,
            platform: 'web',
            screenWidth,
            screenHeight,
            viewportWidth,
            viewportHeight,
        };
        mixpanel.track(event, eventData);
    }
}

export function logEventBranch(event) {
    if (TRACKING_INIT) {
        branch.logEvent(event);
    }
}

export function identify(idUsuario, idImplementacion) {
    if (!idUsuario && !idImplementacion) return;
    mixpanel.identify(`${idUsuario}_${idImplementacion}`);
    branch.setIdentity(`${idUsuario}_${idImplementacion}`);
}
